// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> cavalli-at-iron-horse-station
// Generated: 2026-10-05T18:31:58.804Z
// Counts: 1 design, 14 content, 14 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From resort-style afternoons by the pool to easy evenings in the WiFi lounge, every shared space at Cavalli is designed to help you live a little larger just steps from the TEXRail platform.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Designer finishes in every detail</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside to warm wood-style floors, soaring ceilings, and a kitchen dressed in designer cabinetry and gleaming stainless steel. Every thoughtful touch, from the spa-inspired bath to your own private patio, is made to feel effortless and entirely your own.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>A Home That Feels Yours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Resort-style living at Iron Horse Station</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Stretch out poolside, fire up the grill at the picnic area, or unwind in the WiFi lounge after a session in the cardio and strength studio. Set within North Richland Hills' walkable Iron Horse village, our shared spaces give you room to gather, recharge, and connect just steps from the TEXRail platform.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Life Beyond Your Door</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from spacious studio, one-, two-, and three-bedroom layouts ranging from 605 to nearly 1,300 square feet. Each home showcases designer cabinetry and backsplash, stainless steel appliances, vinyl-wood plank flooring, and select touches like nine-foot ceilings, garden tubs or walk-in showers, and in-home washers and dryers. Private patios or balconies extend your living space and bring a little Texas sunshine indoors.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>From the resort-style swimming pool with poolside cabanas to the resident lounge with WiFi, game room, and modern fitness and flex studio, the shared spaces at Cavalli at Iron Horse Station are built for connecting and unwinding. Fire up the grills at the picnic and BBQ area, let your pup loose at the bark park, or take advantage of controlled-access gates, EV charging, and package lockers. It's an upscale, social community just steps from the TRE Iron Horse Station in North Richland Hills.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "VALUE",
    "customValue": "<p>Cavalli at Iron Horse Station offers studio, one-, two-, and three-bedroom homes from 605 to nearly 1,300 square feet, each finished with wood-style flooring, designer cabinetry, and stainless steel appliances. Residents enjoy a resort-style pool, a strength and cardio studio, a WiFi lounge, a game room, a bark park, and a covered picnic and BBQ area. Set just north of Loop 820 near Rufe Snow Drive, the community puts TEXRail commuter rail, everyday shopping, and quick access across the Metroplex right at your door. Schedule a tour to see your future home in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Imagine mornings that begin on your private patio and evenings that wind down beside a resort-style pool, all within North Richland Hills' walkable Iron Horse village. Here, designer interiors and thoughtful community spaces come together steps from the TEXRail platform that links you to downtown Fort Worth, Grapevine, and DFW Airport. Come discover a community built for the way you want to live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cavalli at Iron Horse Station, your furry family members are every bit as welcome as you are. Both dogs and cats can settle right in here, with an on-site bark park, a grooming area, and private fenced yards in select homes giving every pet plenty of room to roam.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "false"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Swimming Pool"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Trade ordinary afternoons for sun-soaked hours by our resort-style pool, where every dip feels like a getaway just steps from home."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "false"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Strength & Cardio Studio"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Power through your routine in a modern strength and cardio studio designed to keep your wellness goals close to home."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "false"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident WiFi Lounge"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Settle into the resident lounge with complimentary WiFi, where you can work, connect, or simply relax in a stylish shared space."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "false"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Bark Park"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Let your furry friend run free at our on-site bark park, a welcoming spot for play and a built-in way to meet the neighbors."
      }
    }
  },
  "amenitycardgrid.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Resident Game Room"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Gather for a little friendly competition in the resident game room, complete with foosball and space to unwind with neighbors after a long day."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious one-bedroom apartment interior at Cavalli at Iron Horse Station"
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Cavalli at Iron Horse Station community building exterior"
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Walkable Iron Horse Station neighborhood near Cavalli apartments"
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style pool amenity at Cavalli at Iron Horse Station"
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool at Cavalli at Iron Horse Station"
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment interior with designer kitchen at Cavalli at Iron Horse Station"
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resident lounge and community spaces at Cavalli at Iron Horse Station"
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt_text": {
        "type": "VALUE",
        "customValue": "Resident walking a dog along the landscaped grounds at Cavalli at Iron Horse Station"
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt_text": {
        "type": "VALUE",
        "customValue": "Lush green community courtyard and outdoor space at Cavalli at Iron Horse Station"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
